import { Link } from "react-router-dom";
import { Zap, ChevronDown, Trophy } from "lucide-react";
import { SplitHeadline } from "@/components/landing/SplitHeadline";
import { ReelPhone } from "@/components/landing/ReelPhone";
import { Marquee } from "@/components/landing/Marquee";
import { CAMPAIGN } from "@/lib/images";

export function Hero({ stats }) {
  return (
    <section className="relative min-h-[100svh] overflow-hidden bg-[#0a0a0b] grain" data-testid="hero">
      {/* energy backdrop */}
      <div className="absolute -top-24 -left-24 w-[42vw] h-[42vw] rounded-full bg-sylhet-green/30 blur-[120px]" />
      <div className="absolute top-1/3 -right-20 w-[38vw] h-[38vw] rounded-full bg-sylhet-red/25 blur-[120px] animate-floaty" />
      <div className="absolute inset-0 opacity-[0.04] bg-[repeating-linear-gradient(90deg,#fff_0_1px,transparent_1px_72px)]" />

      <div className="relative z-10 max-w-content mx-auto px-6 md:px-12 min-h-[100svh] grid lg:grid-cols-12 gap-10 items-center pt-24 pb-10">
        {/* left: copy */}
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 rounded-full border border-sylhet-gold/40 bg-sylhet-gold/10 px-4 py-1.5 mb-6 animate-flicker">
            <Trophy size={15} className="text-sylhet-gold" />
            <span className="text-sylhet-gold text-xs font-bold uppercase tracking-[0.2em] font-bn">১ম পুরস্কার — মোটরবাইক!</span>
          </div>

          <SplitHeadline
            className="font-bn font-bold tracking-tight text-cream leading-[1.08]"
            lineClassName="text-5xl sm:text-7xl lg:text-8xl leading-[1.12] pb-1"
            lines={[
              { text: "তোমার রিল।", color: "#FBF7EF" },
              { text: "তোমার সিলেট।", color: "#F42A41" },
              { text: "তোমার মঞ্চ।", color: "#E0A52E" },
            ]}
          />

          <p className="font-bn text-cream/80 text-lg md:text-2xl mt-7 max-w-xl">
            তোমার ফোনই তোমার ক্যামেরা। একটা রিল বানাও, সিলেটের গল্প বলো — আর জিতে নাও বাইক, আইফোন, ড্রোনসহ দারুণ সব পুরস্কার।
          </p>

          <div className="flex flex-wrap items-center gap-4 mt-9">
            <Link to="/submit" data-testid="hero-submit-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-sylhet-red text-cream font-bn font-bold text-lg px-8 py-4 hover:-translate-y-1 transition-transform animate-glow">
              <Zap size={20} className="fill-cream" /> এখনই তোমার রিল জমা দাও
            </Link>
            <a href="#prizes" data-testid="hero-prizes-link"
              className="inline-flex items-center gap-2 rounded-full border-2 border-cream/30 text-cream font-medium px-7 py-4 hover:bg-cream/10 transition-colors">
              পুরস্কার দেখো <ChevronDown size={18} />
            </a>
          </div>

          <div className="flex items-center gap-8 mt-12">
            <div data-testid="live-counter">
              <div className="font-condensed text-4xl md:text-5xl text-cream tabular-nums leading-none" data-testid="entry-count">
                {(stats?.total_entries ?? 0).toLocaleString()}{(stats?.total_entries ?? 0) > 0 ? "+" : ""}
              </div>
              <div className="text-cream/45 text-xs uppercase tracking-[0.2em] mt-1">রিল জমা পড়েছে</div>
            </div>
            <div className="h-10 w-px bg-cream/15" />
            <div>
              <div className="font-condensed text-4xl md:text-5xl text-sylhet-gold tabular-nums leading-none">5</div>
              <div className="text-cream/45 text-xs uppercase tracking-[0.2em] mt-1">বড় পুরস্কার</div>
            </div>
          </div>
        </div>

        {/* right: phone */}
        <div className="lg:col-span-5 flex justify-center lg:justify-end">
          <div className="relative animate-floaty">
            <div className="absolute -inset-6 rounded-[3rem] bg-gradient-to-tr from-sylhet-red/40 to-sylhet-green/40 blur-2xl" />
            <ReelPhone images={CAMPAIGN.creators} caption="তোমার গল্প বলো" className="relative w-[260px] sm:w-[300px]" />
          </div>
        </div>
      </div>

      {/* bottom hashtag marquee */}
      <div className="absolute bottom-0 inset-x-0 bg-sylhet-red text-cream py-2.5 border-y border-black/10">
        <Marquee
          items={["#madeinsylhet", "•", "#fahimalchoudhury", "•", "তোমার রিল তোমার মঞ্চ", "•", "MADE IN SYLHET", "•"]}
          itemClassName="font-condensed text-lg px-5 uppercase"
        />
      </div>
    </section>
  );
}
